import React from "react";
import axios from "services/axios";
import Axios from "axios";
import { Button, Card, message, Spin, Tag, Avatar, Tooltip } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";
import { errorMessage } from "../../Utils";

class MobbiLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobbiLogs: [],
      isLoading: true,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
    };
  }

  componentDidMount() {
    this.fetchMobbiLog(this.state.page, this.state.limit);
  }

  async fetchMobbiLog(page, limit) {
    const query = `page=${page}&limit=${limit}&search=${
      this.state.search || ""
    }`;
    await axios
      .get(`admin-panel/mobbi/logs?${query}`)
      .then((result) => {
        this.setState({
          mobbiLogs: result.data.logs,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch((e) => {
        errorMessage(e.response || e);
        this.setState({ isLoading: false });
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchMobbiLog(page, limit);
  }

  async downloadPayloadMobbi(item) {
    try {
      let fileName = item.mobbiId;
      let json = JSON.stringify(item.payload);
      let blob = new Blob([json], { type: "application/json" });
      let href = await URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = href;
      link.download = "Payload Mobbi id " + fileName + ".json";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      message.success("Success Download Payload");
    } catch (e) {
      errorMessage(e.response || e);
    }
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "No",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobbi Id",
        options: {
          sort: false,
        },
      },
      {
        name: "Plat Nomor",
        options: {
          sort: false,
        },
      },
      {
        name: "Message",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Dikirim",
        options: {
          sort: false,
        },
      },
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
    ];

    //Data New Car
    const mobbiLogs = this.state.mobbiLogs.map((item, idx) => {
      return [
        this.state.limit * (this.state.page - 1) + (idx + 1),
        item.mobbiId,
        item.licensePlate,
        item.message,
        momentTZ(item.createdAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
        <Button
          style={{
            backgroundColor: "#1890ff",
            color: "white",
          }}
          icon="download"
          onClick={() => this.downloadPayloadMobbi(item)}
        />,
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Mobbi Logs"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={`Mobbi Logs`}
              data={mobbiLogs}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default MobbiLog;



// WEBPACK FOOTER //
// src/components/Dashboard/MobbiLog/MobbiLog.js